module.exports = __webpack_public_path__ + "app/principal/modals/import-modal-buyer-relation-w2cDKIPE.html";